import React, { useState, createContext } from 'react'
import { Vehicle } from '../@types/vehicle'

interface VehiclesContextData {
  vehicles: Vehicle[]
  loading: boolean
  error: string | null
}

const VehiclesContext = createContext<VehiclesContextData>({} as VehiclesContextData)

interface VehiclesProviderProps {
  children: React.ReactNode
}

function VehiclesProvider({ children }: VehiclesProviderProps) {
  const [vehicles, setVehicles] = useState<Vehicle[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  return (
    <VehiclesContext.Provider value={{ vehicles, loading, error }}>
      {children}
    </VehiclesContext.Provider>
  )
};

const useVehicles = () => {
  const context = React.useContext(VehiclesContext)
  if (!context) {
    throw new Error('useVehicles must be used within a VehiclesProvider')
  }
  return context
};

export { VehiclesProvider, useVehicles }